export default async function downloadLocalFile(fileName) {
  const tempLink = document.createElement("a");
  tempLink.style.display = "none";
  tempLink.href = fileName;
  tempLink.setAttribute("download", fileName);
  document.body.appendChild(tempLink);
  tempLink.click();
  document.body.removeChild(tempLink);
}
